// PostDetailJsonLd.js
// TODO: need to check relatedMessageIds
import { connect } from 'react-redux';

import PostDetailJsonLd from '../component/PostDetailJsonLd.jsx';

import getMessageData from '../selector/getMessageData.js';
import getUserData from '../selector/getUserData.js';
import getListData from '../selector/getListData.js';
import getMessageList from '../selector/getMessageList.js';
import getMessageThumbnail from '../selector/getMessageThumbnail.js';
import getMessageHashtagContentList from '../selector/getMessageHashtagContentList.js';

import {
  getAssetManifest,
  MediaAssetFormat,
  MediaPreset,
} from '../resource/getMediaAsset.js';
import { ProfileListType } from '../resource/profileConstants.js';

const mapStateToProps = (state, { messageId, isStoryUi, isFlixUi }) => {
  const senderId = getMessageData(state, messageId, 'senderId');
  const assetIds = getMessageData(state, messageId, 'assetIds');
  const relatedMessageIds = isStoryUi
    ? getMessageList(
        state,
        'outbox',
        ['outbox', ProfileListType.SHORT, senderId],
        'itemIds'
      )
    : isFlixUi
    ? getListData(
        state,
        ['home', 'messages', `message-${messageId}`],
        'itemIds'
      )
    : getMessageList(
        state,
        'outbox',
        ['outbox', ProfileListType.IMAGE, senderId],
        'itemIds'
      );

  return {
    senderId,
    senderName: getUserData(state, senderId, 'username'),
    title: getMessageData(state, messageId, 'title'),
    description: getMessageData(state, messageId, 'description'),
    jpg1x: getMessageThumbnail(
      state,
      messageId,
      '',
      '1024x1024',
      'jpg',
      'clear'
    ),
    postedAtUnix: getMessageData(state, messageId, 'postedAtUnix'),
    viewCount: getMessageData(state, messageId, 'views'),
    unlockCount: getMessageData(state, messageId, 'unlocks'),
    likeCount: getMessageData(state, messageId, 'likes'),
    dislikeCount: getMessageData(state, messageId, 'dislikes'),
    commentCount: getMessageData(state, messageId, 'comments'),
    relatedMessageIds,
    m3u8Url: getAssetManifest({
      id: messageId,
      assetId: assetIds?.[0],
      format: MediaAssetFormat.M3U8,
      preset: MediaPreset.SD,
    })?.href,
    m3u8PreviewUrl: getAssetManifest({
      id: messageId,
      assetId: assetIds?.[0],
      format: MediaAssetFormat.M3U8,
      preset: MediaPreset.SD_PREVIEW,
    })?.href,
    hashtagContentList: getMessageHashtagContentList(state, messageId),
  };
};

export default connect(mapStateToProps)(PostDetailJsonLd);
